import { useOne, useTranslation } from "@refinedev/core";
import { IEInvoiceSetting } from "interfaces";
import Button from "components/button";
import { Link } from "react-router-dom";
import { PencilIcon } from "@heroicons/react/outline";
import { isHaveActionPermission } from "utills/helpers";
import { Label } from "components/label";
import { SwitchButton } from "components/switchButton";
import { FullScreenLoading } from "components/fullScreenLoading";

export const EInvoiceSePayConfigTab: React.FC = () => {
  const { translate } = useTranslation();

  const { data, isFetching } = useOne<IEInvoiceSetting>({
    resource: "organization/einvoice-settings",
    id: "",
    meta: {
      resource: "data",
    },
  });

  const invoiceSettingData = data?.data ?? null;

  if (isFetching) {
    return <FullScreenLoading />;
  }

  return (
    <div>
      <div className="flex items-center justify-end mb-4">
        {isHaveActionPermission("einvoice", "organization", "edit") && (
          <Link to="/organization/einvoice/edit">
            <Button>
              <span className="sr-only">Edit</span>
              <PencilIcon className="w-4 h-4 text-white" />
              <span className="hidden sm:block sm:ml-2">
                {translate("edit")}
              </span>
            </Button>
          </Link>
        )}
      </div>

      {invoiceSettingData ? (
        <div className="box-container">
          <div className="grid gap-x-4 gap-y-4 grid-cols-8 text-sm">
            <div className="col-span-full flex items-center justify-between">
              <p className="font-bold text-base">EInvoice Setting</p>
              <SwitchButton
                disabled
                checked={invoiceSettingData?.einvoice_enabled}
                onChange={() => {}}
                label={
                  invoiceSettingData?.einvoice_enabled
                    ? "Enabled"
                    : "Disabled"
                }
              />
            </div>
            <div className="col-span-full sm:col-span-2">
              <Label id="sepay_username" name="Username" />
              <p>{invoiceSettingData?.sepay_username}</p>
            </div>
            <div className="col-span-full sm:col-span-2">
              <Label id="sepay_template_code" name="Template Code" />
              <p>{invoiceSettingData?.sepay_template_code}</p>
            </div>
            <div className="col-span-full sm:col-span-2">
              <Label
                id="sepay_provider_account_id"
                name="Provider Account Id"
              />
              <p>{invoiceSettingData?.sepay_provider_account_id}</p>
            </div>
            <div className="col-span-full sm:col-span-2">
              <Label id="sepay_invoice_series" name="Invoice Series" />
              <p>{invoiceSettingData?.sepay_invoice_series}</p>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
